<template>
  <div v-if="$route.name === 'Statuses'">
    <admin-filter
      v-model="filterParams"
    />
    <admin-card>
      <template slot="header">
        Список статусов
        <router-link
          class="pull-right btn btn-primary btn-sm"
          :to="{ name: 'StatusCreate'}">
          <i class="fa fa-plus"/> Добавить
        </router-link>
      </template>
        <admin-list :items="items" :loading="loading">
          <template slot="headerList">
            <div class="col-6 col-md-4">Название</div>
            <div class="col-6 col-md-1">Код</div>
            <div class="col-6 col-md-1">Класс</div>
            <div class="col-6 col-md-1">Сортировка</div>
            <div class="col-6 col-md-1">Id статусов в AmoCrm</div>
            <div class="col-6 col-md-2">Управление</div>
          </template>
          <template slot-scope="{ item }">
            <div class="col-6 col-md-4">
              {{item.name}}
            </div>
            <div class="col-6 col-md-1">
              {{item.code}}
            </div>
            <div class="col-6 col-md-1">
              {{item.class}}
            </div>
            <div class="col-6 col-md-1">
              {{item.sort}}
            </div>
            <div class="col-6 col-md-1">
              <span class="badge badge-info text-muted small" v-for="amoStatus in item.amoStatuses">{{amoStatus.name}}</span>
            </div>
            <div class="col-6 col-md-2">
              <router-link
                class="btn btn-primary btn-sm"
                :to="{ name: 'StatusEdit', params: { id: item.id }}">
                <i class="fa fa-edit"/> Изменить
              </router-link>
            </div>
          </template>
        </admin-list>
    </admin-card>
  </div>
  <router-view v-else/>
</template>

<script>
  import getStatusQuery from 'gql/queries/getStatuses.graphql'
  import AdminCard from '../Components/AdminCard'
  import AdminFilter from '../Components/AdminFilter'
  import AdminList from '../Components/AdminList'

  export default {
    name: 'StatusList',
    components: {AdminList, AdminFilter, AdminCard},
    computed: {
      items () {
        return this.itemsPage.statuses !== undefined ? this.itemsPage.statuses : []
      }
    },
    data () {
      return {
        showFilter: false,
        loading: false,
        filterParams: [
        ],
        page: 1,
        itemsPage: {
          paginator: {
            total_count: 1000,
            limit: 10
          }
        }
      }
    },
    apollo: {
      itemsPage: {
        query: getStatusQuery,
        variables () {
          return {
          }
        },
        fetchPolicy: 'network-only',
        watchLoading (isLoading, countModifier) {
          this.loading = isLoading
        },
        update: (data) => {
          return data
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// StatusList.vue?56631149